import { render } from "./NavBar.vue?vue&type=template&id=d652b452&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=d652b452&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2236819739/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d652b452"]])

export default __exports__